<template>
  <!-- 订单列表 -->
  <div class="order-list">
    <header>
      <img src="../../assets/images/card-img/buy-card-img/icon-24-fanhui.png" alt="" @click="$router.replace('/my')"> 
      <p>
        我的订单
      </p>
    </header>
    <section>
      <!-- 订单列表 -->
      <div class="order-show" @click="moreBtn">
        <!-- 订单标题 -->
        <p class="title">
          珍爱女性相约浪漫女人岛
        </p>
        <div class="content">
          <div class="order-img">
            <img src="../../assets/images/activity-img/activity-detail-img/event-img.png" alt="">
          </div>
          <div class="order-msg"> 
            <p class="order-date">
              购买日期：<span>2020/3/18   15:30</span>
            </p>
            <div class="order-name">
              <p>
                下单人姓名：<span>尹天仇</span>
              </p>
              <p>
                ￥3999元
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data(){
    return{

    }
  },
  methods:{
    moreBtn(){
      this.$router.replace('/order-more')
    }
  }
}
</script>
<style lang="less" scoped>
  .order-list{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    header{
      width: 100%;
      height: .88rem;
      display: flex;
      align-items: center;
      img{
        width: .18rem;
        height: .35rem;
        margin-left: .33rem;
      }
      p{
        width: 6.54rem;
        font-family: PingFang-SC-Bold;
        color: #333333;
        font-size: 0.36rem;
        font-weight: bold;
        text-align: center;
      }
    }
    section{
      width: 100%;
      height: 100%;
      background: #F0F0F0;
      // 订单列表
      .order-show{
        width: 6.69rem;
        height: 2.45rem;
        margin: 0 auto;
        margin-top: .2rem;
        background: #ffffff;
        border-radius: 0.2rem;
        overflow: hidden;
        // 订单标题
        .title{
          font-size: 0.32rem;
          line-height: .32rem;
          font-family: PingFang SC;
          font-weight: bold;
          color: rgba(51,51,51,1);
          margin-top: .2rem;
          margin-left: .21rem;
        }
        // 内容
        .content{
          margin-top: .31rem;
          display: flex;
          // 图片
          .order-img{
            img{
              width: 2.24rem;
              height: 1.33rem;
              margin-left: .19rem;
            }
          }
          .order-msg{
            margin-top: .19rem;
            // 订单时间
            .order-date{
              margin-left: .23rem;
              font-family: PingFang-SC-Regular;
              color: #333333;
              font-size: 0.24rem;
              line-height: .24rem;
            }
          }
          // 名字 价格
          .order-name{
            margin-left: .22rem;
            margin-top: .35rem;
            p{
              // 名字
              &:first-child{
                font-family: PingFang-SC-Regular;
                color: #333333;
                font-size: 0.24rem;
                line-height: .24rem;
                float: left;
              }
              // 价格
              &:last-child{
                float: right;
                line-height: .24rem;
                font-size:0.28rem;
                font-family:PingFang SC;
                font-weight:bold;
                color:rgba(239,130,1,1);
                margin-left: .45rem;
              }
            }
          }
        }
      }
    }
  }
</style>